$(document).ready(function(){

  $('.m-menu').click(function(){
    $('html, body').toggleClass('noscroll');
    $('body').toggleClass('m-menu-open');
  });

  $('.home .items').on('init', function(event, slick){
    $('.slick-slider').find("[data-slick-index='0']").addClass('activated')
  });
  $('.home .items').on('afterChange', function(event, slick, currentSlide){
    $('.slick-slider').find("[data-slick-index='" + currentSlide + "']").addClass('activated')
  });
  $('.home .items').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('.activated').removeClass('activated')
  });
  $('.home .items').slick({
    dots: true
  });

  $('.shows-page .items').on('init', function(event, slick){
    $('.slick-slider').find("[data-slick-index='0']").addClass('activated')
  });
  $('.shows-page .items').on('afterChange', function(event, slick, currentSlide){
    $('.slick-slider').find("[data-slick-index='" + currentSlide + "']").addClass('activated')
  });
  $('.shows-page .items').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('.activated').removeClass('activated')
  });
  $('.shows-page .items').slick({
    dots: false
  });


  $('.work-page .items').on('init', function(event, slick){
    $('.slick-slider').find("[data-slick-index='0']").addClass('activated')
  });
  $('.work-page .items').on('afterChange', function(event, slick, currentSlide){
    $('.slick-slider').find("[data-slick-index='" + currentSlide + "']").addClass('activated')
  });
  $('.work-page .items').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('.activated').removeClass('activated')
  });
  $('.work-page .items').slick({
    dots: false
  });

  $(".slick-slider").on('mousemove', function(e) {
    if ((e.pageX - this.offsetLeft) < $(this).width() / 2) {
        $('.slick-prev').addClass('active');
        $('.slick-next').removeClass('active');
    } else {
        $('.slick-prev').removeClass('active');
        $('.slick-next').addClass('active');
    }
  });
  $(".slick-slider").on('mouseleave',function(){
    $('.slick-prev').removeClass('active');
    $('.slick-next').removeClass('active');
  })

  $('.all-exhibitions').click(function(e){
    e.preventDefault();
    $('.old-exhibitions').show();
    $('.upcoming-exhibitions').show();
    $(this).hide();
  });
  $('.upcoming-exhibitions').click(function(e){
    e.preventDefault();
    $('.old-exhibitions').hide();
    $('.all-exhibitions').show();
    $(this).hide();
  });



  // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // We listen to the resize event
  window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });

  $('.nl-toggle').click(function(e){
    e.preventDefault();
    $('.nl').toggleClass('open');
    if ($('.nl').hasClass('open')) {
      $('.email').focus();
    }
  })

});